import React, { useState } from 'react';
import Icon from './Icon';

const CreateTournament = ({ onBack, onCreate }) => {
  const [name, setName] = useState('');
  const [swissRounds, setSwissRounds] = useState(3);
  const [hasTopCut, setHasTopCut] = useState(false);
  const [topCutSize, setTopCutSize] = useState(4);

  const handleCreate = () => {
    if (!name.trim()) return;
    onCreate({ name, swissRounds, hasTopCut, topCutSize: hasTopCut ? topCutSize : 0 });
  };

  return (
    <div className="min-h-screen p-4">
      <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
        <Icon d="M15 19l-7-7 7-7" />
        Retour
      </button>

      <h1 className="text-2xl font-bold mb-6">Nouveau Tournoi</h1>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">Nom du tournoi</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:border-red-500"
            placeholder="Ex: FNM 31/10/2025"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Nombre de rounds suisse</label>
          <input
            type="number"
            min="1"
            max="10"
            value={swissRounds}
            onChange={(e) => setSwissRounds(parseInt(e.target.value))}
            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:border-red-500"
          />
        </div>

        <div className="flex items-center justify-between bg-gray-800 p-4 rounded-lg">
          <span className="font-medium">Top Cut</span>
          <button
            onClick={() => setHasTopCut(!hasTopCut)}
            className={`w-14 h-8 rounded-full transition ${hasTopCut ? 'bg-red-600' : 'bg-gray-600'}`}
          >
            <div className={`w-6 h-6 bg-white rounded-full transition transform ${hasTopCut ? 'translate-x-7' : 'translate-x-1'}`} />
          </button>
        </div>

        {hasTopCut && (
          <div>
            <label className="block text-sm font-medium mb-2">Taille du Top Cut</label>
            <div className="grid grid-cols-2 gap-2">
              {[4, 8].map(size => (
                <button
                  key={size}
                  onClick={() => setTopCutSize(size)}
                  className={`py-3 rounded-lg font-semibold ${topCutSize === size ? 'bg-red-600' : 'bg-gray-800'}`}
                >
                  Top {size}
                </button>
              ))}
            </div>
          </div>
        )}

        <button
          onClick={handleCreate}
          disabled={!name.trim()}
          className="w-full bg-red-600 text-white py-4 rounded-lg font-semibold disabled:bg-gray-700 disabled:text-gray-500 mt-6"
        >
          Créer le tournoi
        </button>
      </div>
    </div>
  );
};

export default CreateTournament;